/**
 * Per-device memory of the welcome card's minimized state, keyed by community
 * AND content: a replaced video shows large again. `null` means the member
 * never chose, so the card follows the `watched` flag.
 */
const STORAGE_KEY = "welcome_video_card";

function readAll() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
        return {};
    }
}

export function readMinimized(communityId, contentId) {
    if (!communityId || !contentId) return null;
    const value = readAll()[`${communityId}:${contentId}`];
    return typeof value === "boolean" ? value : null;
}

export function writeMinimized(communityId, contentId, minimized) {
    if (!communityId || !contentId) return;
    try {
        const all = readAll();
        all[`${communityId}:${contentId}`] = !!minimized;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    } catch {
        // Storage unavailable (private mode): the choice lasts the session.
    }
}
